import React from 'react';
import { Link, Route } from 'react-router-dom';
import "./Navbar.css";
  
const Navbar = () => {
    /*const highlighter1 = function(){
        document.getElementById("one").classList.add("active");
        document.getElementById("two").classList.remove("active");
        document.getElementById("three").classList.remove("active");
    }
    const highlighter2 = function(){
        document.getElementById("one").classList.remove("active");
        document.getElementById("two").classList.add("active");
        document.getElementById("three").classList.remove("active");
    }
    const highlighter3 = function(){
        document.getElementById("one").classList.remove("active");
        document.getElementById("two").classList.remove("active");
        document.getElementById("three").classList.add("active");
    }*/
   
   
    return (
        <div>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" integrity="sha512-iBBXm8fW90+nuLcSKlbmrPcLa0OT92xO1BIsZ+ywDWZCvqsWgccV3gFoRBv0z+8dLJgyAHIhR35VZc2oM/gI1w==" crossorigin="anonymous" referrerpolicy="no-referrer" />  

            <nav>
            
                <div className="title">
                    <Link to="/"><header><i class="fas fa-headset"></i>The Bro-Cave</header></Link>
                    <input type="checkbox" id="check" />
          <label for="check" class="checkbtn">
            <i class="fas fa-bars"></i>
           </label>
                <ul className="please">
                             
                <Link to="/" className="li " ><a  id="one">Home</a></Link>
                <Link to="/Items" className="li" ><a id="two">Items</a></Link>
                <Link to="/Cart" className="li" ><a id="three"><i class="fas fa-shopping-cart"></i>Cart</a></Link>
               {/*} <input type="checkbox" id="check"/><label for="check">
                <Link className="icon"><i class="fas fa-bars"></i></Link></label>*/}
                </ul>
                    
                </div>   
            </nav>
        </div>
    )
}

export default Navbar
